import { render, staticRenderFns } from "./NewsPromoTag.vue?vue&type=template&id=751d1b56&scoped=true&"
import script from "./NewsPromoTag.vue?vue&type=script&lang=js&"
export * from "./NewsPromoTag.vue?vue&type=script&lang=js&"
import style0 from "./NewsPromoTag.vue?vue&type=style&index=0&id=751d1b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751d1b56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751d1b56')) {
      api.createRecord('751d1b56', component.options)
    } else {
      api.reload('751d1b56', component.options)
    }
    module.hot.accept("./NewsPromoTag.vue?vue&type=template&id=751d1b56&scoped=true&", function () {
      api.rerender('751d1b56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/NewsPromoTag.vue"
export default component.exports